import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AddNewRegion from "../pages/dashboardPage/regionSettings/addNewRegion/AddNewRegion";
import AllRegions from "../pages/dashboardPage/regionSettings/allRegions/AllRegions";
import EditRegion from "../pages/dashboardPage/regionSettings/editRegion/EditRegion";
import RegionImages from "../pages/dashboardPage/regionSettings/regionImages/RegionImages";

// Tab id (permissionCatalog "regions") → its page.
const TAB_PAGES = {
  "all-regions": AllRegions,
  "add-region": AddNewRegion,
  "region-images": RegionImages,
};

const RegionNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("regions", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {/* Not a tab: opened from the region card's edit button. */}
      {rolePermissions.includes("update-regions") && (
        <Route path="/edit-region" element={<EditRegion />} />
      )}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default RegionNavigator;
